import { render } from "./policy-details.vue?vue&type=template&id=4e74287b&scoped=true"
import script from "./policy-details.vue?vue&type=script&lang=js"
export * from "./policy-details.vue?vue&type=script&lang=js"

import "./policy-details.vue?vue&type=style&index=0&id=4e74287b&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e74287b"]])

export default __exports__